<div [class.hidden]="isRouteSet" class="heading selection-label">
  Select a route
</div>
<ng-container *ngIf="isRouteSet">

  <div class="heading selection-label" [attr.title]="routeName">
    <div>Route:</div>
    <span [innerHTML]="routeName"></span><span [class.hidden]="isExpanded"> with subroutes</span><span [class.hidden]="!isExpanded"> only</span>
  </div>
  <div class="heading">
    Estimated Cost:
  </div>
  <div class="totals">
    <div [class.hidden]="!route" class="totals">
      <label [class.hidden]="materialCost == ''">Materials: <span [innerHTML]="materialCost"></span></label>
      <label [class.hidden]="laborCost == ''">Labor: <span [innerHTML]="laborCost"></span></label>
      <label  [class.hidden]="supplCost == ''">Supplemental: <span [innerHTML]="supplCost"></span></label>
      <label  [class.hidden]="totalCost == ''">Total: <span [innerHTML]="totalCost"></span></label>
    </div>
  </div>
  <div class="heading">Reports</div>
  <div class="nav">
    <button (click)="ShowCostReport()" type="button" class="btn btn-sm btn-primary">
      Cost
    </button>
    <button (click)="ShowSummaryReport()" type="button" class="btn btn-sm btn-primary">
      Summary
    </button>
    <button (click)="ShowSupplReport()" type="button" class="btn btn-sm btn-primary">
      Supplemental
    </button>
  </div>
  <div [class.hidden]="!isExpanded" class="instruction">
    Collapse route to include subroutes in reports and reported total.
  </div>
  <div [class.hidden]="isExpanded" class="instruction">
    Expand route to show totals and report based on the current route without sub routes.
  </div>
</ng-container>
